module.exports = __webpack_public_path__ + "img/course.e048508.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/course.png
// module id = UYEr
// module chunks = 2